var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          staticClass: "login-button mb-4",
          attrs: { outlined: "", large: "", depressed: "" },
          on: { click: _vm.signInWithGoogle },
        },
        [
          _c("img", {
            staticClass: "logo-google",
            attrs: { src: _vm.firebase_host + "/static/img/google.png" },
          }),
          _vm._v("\n    Login con Google"),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "login-button",
          attrs: { outlined: "", large: "", depressed: "" },
          on: { click: _vm.signInWithApple },
        },
        [
          _c("v-icon", { staticClass: "black--text", attrs: { left: "" } }, [
            _vm._v("fa-apple"),
          ]),
          _vm._v("\n    Login con Apple"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }